import { QueryKeys } from "@/constants/Query";
import axiosInstance from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";

interface S3DownloadParams {
  path: string;
  enabled?: boolean;
  patientId: string;
}

export const useS3Download = ({
  patientId,
  path,
  enabled = true,
}: S3DownloadParams) => {
  const params = {
    path,
  };

  return useQuery({
    queryFn: async () => {
      const response = await axiosInstance.get<Blob>("/storage/s3-download", {
        params,
        responseType: "blob",
      });

      return response.data;
    },
    queryKey: QueryKeys.Patient.Files.S3({
      patientId,
      path,
    }),
    enabled,
  });
};
